import React from "react";
import { StoryCard } from "../basic/story-card.js"
import { CollectionName } from "../basic/collection-name.js";
import { DfpAd } from "../dfp-ad"
import { wrapCollectionLayout } from "@quintype/components";

import "./l-shape-one-widget.m.css";


function LShapeOneWidgetLayoutBase({collection, stories, config, associatedMetadata}) {
  const primarStoryCardConfig = {
    section: true,
    subheadline: true,
    image: true,
    imageAspectRatio: [4,3]
  }
  const storyListConfig = {
    image: true
  }
  const  {'show_collection_title': collectionName = true} = associatedMetadata;

  return (
    <div styleName="component-wrapper" data-test-id = "l-shape-grid-component">
      {collectionName ? <CollectionName name={collection.name} type="large" section={collection}/> : null }
      <div styleName="first-row">
        <div styleName="feature-story">
          <StoryCard hideSectionName={true} story={stories[0]} config={primarStoryCardConfig} type="imageBackground"/>
        </div>
        <div className="app-ad app-ad--vertical">
          <DfpAd adtype="Vertical-Ad" layoutName="LShapeOneWidget" collectionSlug={collection.slug}/>
        </div>
      </div>

      <div styleName="second-row">
        {stories.slice(1,4).map((story) => {
          return <div  key={story.id}>
            <StoryCard hideSectionName={true} config={storyListConfig} story={story}/>
          </div>
        })}
      </div>
      <div className="app-ad app-ad--horizontal">
        <DfpAd adtype="Horizontal-Ad" layoutName="LShapeOneWidget" collectionSlug={collection.slug}/>
      </div>
    </div>
  )

}

export const LShapeOneWidget = wrapCollectionLayout(LShapeOneWidgetLayoutBase);
